import { Inject, Injectable, Optional } from '@angular/core';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';
import { StoryblokService } from '~app/modules/storyblok/services';
import { StoryblokApiResponse } from '~app/modules/storyblok/models/storyblok-api-response.model';
import { NUMBER_0, NUMBER_1 } from "~shared/constants";
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

enum PATHS {
  content = 'content', // landing page
  landing = 'landing' // custom plp
}

@Injectable({
  providedIn: 'root',
})
export class StoryblokGuard implements CanLoad {
  constructor(private router: HomepageNavigatorService,
              private storyblokService: StoryblokService,
              @Optional() @Inject(REQUEST) private webAppBuyerRequest: any) {}

  canLoad(_route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const storyPath: string = this.createStoryPath(segments)
    const storySlug: string = segments[NUMBER_1]?.path

    if (storyPath && storySlug) {
      return this.loadStoryblokStory(`${storyPath}/${storySlug}`);
    }

    return this.router.navigateToHomepage();
  }

  private loadStoryblokStory(rawUrl: string): Observable<boolean> {
    const market = getCountryDomainCode(this.webAppBuyerRequest);
    const url = rawUrl.replace('{market}', market);
    const story$: Observable<StoryblokApiResponse> = this.storyblokService.getStoryByHttp(url);
    return story$.pipe(
      take(1),
      switchMap((storyResponse: StoryblokApiResponse) => {
        const { story } = storyResponse;
        return !!story ? of(true) : this.router.navigateToHomepage();
      }),
      catchError(() => this.router.navigateToHomepage())
    );
  }

  private createStoryPath(segments: Array<UrlSegment>): string {
    if (segments && !!segments.length) {
      const path = PATHS[segments[NUMBER_0].path]
      return !!path ? `{market}/${path}` : null;
    }

    return null;
  }
}
